let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hXx3W")).then(() => parcelRequire('9aF4A'));